/**
 * BountyAcceptedSubmissionPage: bounty-owner view of the accepted submission for
 * one of their listings, rendered at /account/listings/:bountyId/submissions/accepted
 * (nested under UserHomepage). Pure composition, no local state or API calls:
 * stacks pages/bounty/SubheadedBountyDisplay (type="owner") above
 * pages/submission/SubmissionDisplay (submissionType="normal", type="accepted").
 */
import SubheadedBountyDisplay from "@/pages/bounty/SubheadedBountyDisplay";
import SubmissionDisplay from "@/pages/submission/SubmissionDisplay";

const BountyAcceptedSubmissionPage: React.FC = () => {
    return (
        <div className="flex flex-col w-full">
            <SubheadedBountyDisplay type="owner" />
            <SubmissionDisplay submissionType="normal" type="accepted" />
        </div>
    );
};

export default BountyAcceptedSubmissionPage;
